import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  id: "index",
  class: "pb-xl-2 mb-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle h4 bg-c02 text-white rounded-top-1 p-2 px-3" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-calendar-check-o",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "スケジュール一覧")
], -1)
const _hoisted_3 = { class: "bg-white rounded-bottom-1 p-3 p-sm-4 py-2 py-sm-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["id", "onClick"]
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "d-inline-block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fs-x-small hoge" }, "年", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fs-x-small hoge" }, "月", -1)
const _hoisted_10 = { class: "fs-x-small hoge" }
const _hoisted_11 = { class: "d-inline-block align-middle rounded fs-small lh-1 fw-bold bg-white text-c02 py-1 px-2 mb-1 ms-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs-x-small" }, "件", -1)
const _hoisted_13 = { class: "col-auto me-auto d-none d-sm-flex" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "js-accordion-icon" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1)
const _hoisted_16 = { class: "table-responsive scrollbar pb-3" }
const _hoisted_17 = { class: "table table-bordered h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleLegend = _resolveComponent("ScheduleLegend")!
  const _component_ColGroupByMobile = _resolveComponent("ColGroupByMobile")!
  const _component_ColGroupByPc = _resolveComponent("ColGroupByPc")!
  const _component_TableHead = _resolveComponent("TableHead")!
  const _component_TableBody = _resolveComponent("TableBody")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ScheduleLegend),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schedules.daily, (daily, key, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "js-accordion",
          key: key
        }, [
          _createElementVNode("dl", _hoisted_4, [
            _createElementVNode("dt", {
              id: 'daily_' + index,
              class: _normalizeClass(["row g-0 align-items-center p-1 px-3 mb-1", { active: index < 3 }]),
              onClick: ($event: any) => (_ctx.toggleAccordion('daily_' + index))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", _hoisted_7, [
                  _createTextVNode(_toDisplayString(daily.dateFormat.year) + " ", 1),
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(daily.dateFormat.month) + " ", 1),
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(daily.dateFormat.day) + " ", 1),
                  _createElementVNode("span", _hoisted_10, " 日" + _toDisplayString(daily.dateFormat.weekday), 1)
                ]),
                _createElementVNode("span", _hoisted_11, [
                  _createTextVNode(_toDisplayString(daily.count) + " ", 1),
                  _hoisted_12
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-c03 lh-sm rounded-pill py-1 px-3",
                  href: daily.dateFormat.createScheduleRoute,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, " 新規追加 ", 8, _hoisted_14)
              ]),
              _hoisted_15
            ], 10, _hoisted_5),
            _createElementVNode("dd", {
              class: "mb-2",
              style: _normalizeStyle([index < 3 ? 'display: block;' : ''])
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("table", _hoisted_17, [
                  (_ctx.isMobile)
                    ? (_openBlock(), _createBlock(_component_ColGroupByMobile, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_ColGroupByPc, { key: 1 })),
                  _createVNode(_component_TableHead, { "is-mobile": _ctx.isMobile }, null, 8, ["is-mobile"]),
                  _createVNode(_component_TableBody, {
                    schedules: daily.schedules,
                    isDaily: true,
                    "is-mobile": _ctx.isMobile
                  }, null, 8, ["schedules", "is-mobile"])
                ])
              ])
            ], 4)
          ])
        ]))
      }), 128))
    ])
  ]))
}